var map = {
	"./1.svg": 7744,
	"./2.svg": 2291,
	"./3.svg": 9650,
	"./4.svg": 4317,
	"./5.svg": 4604,
	"./6.svg": 9951,
	"./7.svg": 5198,
	"./8.svg": 1929,
	"./android.svg": 7552,
	"./arrow.svg": 8630,
	"./avo-btn.svg": 4166,
	"./burger.svg": 100,
	"./check.svg": 7121,
	"./ios.svg": 5486,
	"./tg.svg": 4248,
	"./x.svg": 5081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7521;